export const FileAdminFilterKey = {
  Purpose: 'purpose',
  State: 'state.status',
  Mimetype: 'mimeType',
} as const;
export type FileAdminFilterKey = (typeof FileAdminFilterKey)[keyof typeof FileAdminFilterKey];
export const FILE_ADMIN_FILTER_KEYS = [
  FileAdminFilterKey.Purpose,
  FileAdminFilterKey.State,
  FileAdminFilterKey.Mimetype,
] as const;
